import Header from "../../components/Header/Header";
import NavInf from "../../components/NavInf/NavInf";
import Footer from "../../components/Footer/Footer";
import Alert from "../../components/Alert/Alert";
import CrearCliente from "../../components/CrearCliente/CrearCliente";
import './MyCustomers.css'
import { useEffect, useState, useCallback } from "react";
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase';
import secureAxios from '../../utils/secureAxios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios'; // <-- Este es el limpio, sin headers

const checkIfPhoneExists = async (numeroLocal) => {
    try {
        const res = await axios.get(`https://api.minymol.com/users/resolve-phone/${numeroLocal}`);
        return !!res.data.phoneNumber;
    } catch (err) {
        return false;
    }
};


const MyCustomers = () => {
    const [busqueda, setBusqueda] = useState('');
    const [clientes, setClientes] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');

    const [clienteEditar, setClienteEditar] = useState(null);

    const handleEditar = (cliente) => {
        setClienteEditar(cliente);
    };

    const handleActualizacion = (clienteActualizado) => {
        if (clienteActualizado) {
            setClientes(prev =>
                prev.map(c => (c.id === clienteActualizado.id ? clienteActualizado : c))
            );
        }
        setClienteEditar(null); // <-- esto limpia el modo edición
    };


    const handleEliminar = async (clienteId) => {
        try {
            await secureAxios.delete(`/customers/${clienteId}`);
            setClientes(prev => prev.filter(c => c.id !== clienteId));
            setAlertType('success');
            setAlertMessage('Cliente eliminado correctamente');
            setShowAlert(true);
        } catch (err) {
            setAlertType('error');
            setAlertMessage('Error al eliminar cliente');
            setShowAlert(true);
        }
    };

    const fetchClientes = useCallback(async () => {
        try {
            const res = await secureAxios.get('/customers', {
                params: busqueda.trim() ? { query: busqueda.trim() } : {}
            });

            const enriched = await Promise.all(res.data.map(async (cliente) => {
                const hasAccount = await checkIfPhoneExists(cliente.celular);
                return { ...cliente, hasAccount };
            }));

            setClientes(enriched);
        } catch (err) {
            console.error('Error al cargar clientes:', err);
        }
    }, [busqueda]);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                fetchClientes();
            }
        });

        return () => unsubscribe();
    }, [fetchClientes]);



    const toggleExclusividad = async (clienteId, esExclusivo) => {
        try {
            const endpoint = esExclusivo
                ? `/customers/${clienteId}/remove-exclusive`
                : `/customers/${clienteId}/exclusive`;

            await secureAxios.patch(endpoint);

            setClientes(prev =>
                prev.map(c =>
                    c.id === clienteId ? { ...c, isExclusive: !esExclusivo } : c
                )
            );

            setAlertType('info');
            setAlertMessage('Exclusividad actualizada');
            setShowAlert(true);
        } catch (err) {
            setAlertType('error');
            setAlertMessage('Hubo un error al actualizar');
            setShowAlert(true);
            console.error('Error al cambiar exclusividad:', err);
        }
    };

    return (
        <>
            {showAlert && (
                <Alert
                    type={alertType}
                    message={alertMessage}
                    onClose={() => setShowAlert(false)}
                />
            )}

            <Header
                minimal={true}
                providerName={JSON.parse(localStorage.getItem('usuario'))?.proveedorInfo?.nombre_empresa}
                menuProvider={true}
                currentPage='customers'
            />
            <div className="customers-container">
                <h1>Lista de clientes</h1>
                <CrearCliente
                    onClienteCreado={(nuevoCliente) => {
                        const yaExiste = clientes.some(c => c.celular === nuevoCliente.celular);
                        if (!yaExiste) {
                            setClientes(prev => [...prev, nuevoCliente]);
                        }
                    }}
                    clienteEditar={clienteEditar}
                    onClienteActualizado={handleActualizacion}
                />

                <div className="busqueda-clientes">
                    <input
                        type="text"
                        placeholder="Buscar por nombre, celular o ciudad"
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') fetchClientes();
                        }}
                    />
                    <button onClick={fetchClientes}>Buscar</button>
                </div>


                <div className="list-products-container costumer">
                    <table>
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Celular</th>
                                <th>Direccion</th>
                                <th>Ciudad</th>
                                <th>Departamento</th>
                                <th>Exclusividad</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientes.map((cliente) => (
                                <tr key={cliente.id} className={cliente.isExclusive ? "exclusive" : ""}>
                                    <td>{cliente.nombre}</td>
                                    <td>+57 {cliente.celular}</td>
                                    <td>{cliente.direccion}</td>
                                    <td>{cliente.ciudad}</td>
                                    <td>{cliente.departamento}</td>
                                    <td>
                                        <div className="check-exclusive">
                                            <input
                                                type="checkbox"
                                                checked={cliente.isExclusive || false}
                                                onChange={() => toggleExclusividad(cliente.id, cliente.isExclusive)}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="actions">
                                            <button
                                                className="edit"
                                                onClick={() => handleEditar(cliente)}
                                                disabled={cliente.hasAccount}
                                                title={cliente.hasAccount ? "Este cliente ya está registrado y no puede ser editado" : ""}
                                            >
                                                <FontAwesomeIcon icon={faPen} />
                                            </button>
                                            <button
                                                className="delete"
                                                onClick={() => handleEliminar(cliente.id)}
                                                disabled={cliente.hasAccount}
                                                title={cliente.hasAccount ? "Este cliente ya está registrado y no puede ser eliminado" : ""}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            </div>
            <NavInf />
            <Footer />
        </>
    );
}

export default MyCustomers;